import type { AppRouteRecordRaw, AppRouteModule } from '/@/router/types';

import { PAGE_NOT_FOUND_ROUTE } from '/@/router/routes/basic';

import { mainOutRoutes } from './mainOut';
import home from './modules/home';
import service from './modules/service';
import setting from './modules/setting';
import study from './modules/study';
import staff from './modules/staff';

const routeModuleList: AppRouteModule[] = [];
routeModuleList.push(...[home, service, study, staff, setting]);

// 文件是降序，会打乱菜单顺序
// const modules = import.meta.globEager('./modules/**/*.ts');
// console.log(Object.keys(modules));
// Object.keys(modules).forEach((key) => {
//   const mod = modules[key].default || {};
//   const modList = Array.isArray(mod) ? [...mod] : [mod];
//   routeModuleList.push(...modList);
// });

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE, ...routeModuleList];

export const RootRoute: AppRouteRecordRaw = {
  path: '/',
  name: 'Root',
  redirect: '/home',
  meta: {
    title: 'Root',
  },
};

export const LoginRoute: AppRouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('@/views/login/index.vue'),
  meta: {
    title: '登录',
  },
};
// // Basic routing without permission
export const basicRoutes = [
  LoginRoute,
  RootRoute,
  ...mainOutRoutes,
  ...asyncRoutes,
];
